/**
 * Central product configuration for the preliminary application flow.
 * All limits are verified with the product owner — do not modify without approval.
 */

export const PRODUCT_LIMITS = [
  {
    slug: 'istehlak-kreditleri',
    label: 'İstehlak Krediti',
    amountMin: 300,
    amountMax: 10000,
    termMin: 3,
    termMax: 36,
  },
  {
    slug: 'qizil-kreditleri',
    label: 'Qızıl Krediti',
    amountMin: 300,
    amountMax: 30000,
    termMin: 3,
    termMax: 36,
  },
  {
    slug: 'avto-lizinq',
    label: 'Avto Lizinq',
    amountMin: 2000,
    amountMax: 30000,
    termMin: 3,
    termMax: 48,
  },
];

export const getProductBySlug = (slug) =>
  PRODUCT_LIMITS.find((p) => p.slug === slug) || null;

export const getProductByLabel = (label) =>
  PRODUCT_LIMITS.find((p) => p.label === label) || null;

/**
 * Azerbaijani number formatting: 5000 → "5 000", 15000 → "15 000".
 * Accepts a number or a numeric string (may include non-digits, which are stripped).
 */
export const formatAmountAz = (raw) => {
  const digits = String(raw ?? '').replace(/\D/g, '');
  if (!digits) return '';
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

/**
 * Build the permitted duration list for a given product (every whole month
 * from termMin through termMax, inclusive).
 */
export const getDurationOptions = (product) => {
  if (!product) return [];
  const opts = [];
  for (let m = product.termMin; m <= product.termMax; m += 1) opts.push(m);
  return opts;
};

/**
 * Curated, user-friendly term presets (in months) filtered to the product's
 * allowed range. Ensures termMin and termMax are always included so the user
 * can pick the shortest / longest permitted plan without scrolling a huge list.
 */
const TERM_PRESETS = [3, 6, 9, 12, 18, 24, 30, 36, 48, 60];

export const getTermPresets = (product) => {
  if (!product) return [];
  const set = new Set(
    TERM_PRESETS.filter((m) => m >= product.termMin && m <= product.termMax)
  );
  set.add(product.termMin);
  set.add(product.termMax);
  return Array.from(set).sort((a, b) => a - b);
};
